<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img class="w-100 h-100" src="../img/support/header_bj.png" alt />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/support/mb_support_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Posición actual：
        </span>
        <el-breadcrumb-item :to="{ path: '/ESP' }">HOME</el-breadcrumb-item>
        <el-breadcrumb-item>SOPORTE</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="main_top">
        <p class="main_top_header w-100">Preguntas generales</p>
        <div class="main_top1" v-for="(item,index) in supportA" :key="index" :class="activeIndexA===index ? 'active' : '' " @click="ArticleDetailA(index)">
          <div class="main_top1_header w-100">
            <div class="main_top_text">{{supportA[index].name2}}</div>
            <img
              class="jian"
              style="float: right;margin-top:21px;"
              src="../img/support/矩形2.png"
            />
            <img class="jia" style="float: right;margin-top:7px;" src="../img/support/矩形1.png" />
          </div>
          <div v-show="activeIndexA===index" class="main_top1_txt" v-html="supportA[index].s_content"></div>
        </div>
      </div>
      <div class="main_bottom">
        <p class="main_top_header mt-2">Osmosis inversa</p>
        <div class="main_bottom1" v-for="(item,index) in support" :key="index" :class="activeIndex===index ? 'active' : '' " @click="ArticleDetail(index)">
          <div class="main_top1_header w-100" @click="wt1">
            <div class="main_top_text">{{support[index].name2}}</div>
            <img
              class="jian"
              style="float: right;margin-top:21px;"
              src="../img/support/矩形2.png"
            />
            <img class="jia" style="float: right;margin-top:7px;" src="../img/support/矩形1.png" />
          </div>
          <div v-show="activeIndex===index" class="main_top1_txt" v-html="support[index].s_content"></div>
        </div>
      </div>
    </div>
    <myfooter class="footer"></myfooter>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
  margin: 0 auto;
}
.main {
  width: 100%;
  margin: 0 auto;
}
.main_bottom{
  width: 100%;
  background: url('../img/support/mian_bj.png');
  background-size:cover;
  padding-bottom: 40px;
}
.footer{
  margin-top: -50px !important;
}
.header-bj{
  margin-top: 40px;
}
.main_bottom1 {
  box-shadow: 0px 1px 5px #d4d4d4;
  padding: 20px 40px;
  margin-top: 20px;
  width: 80%;
  margin: 20px auto;
  background-color:#fff ;
}
.main_bottom1 .jian, .main_bottom1.active .jia{
    display: none;
}
.main_bottom1.active .jian{
    display: block;
}
.main_top1 {
  box-shadow: 0px 1px 5px #d4d4d4;
  padding: 20px 40px;
}
.main_top1 .jian, .main_top1.active .jia{
    display: none;
}
.main_top1.active .jian{
    display: block;
}
.main_top_header {
  color: #068bfb;
  text-align: left;
  font-size: 40px;
  width: 80%;
  margin: 0 auto;
}
.main_top1_header {
  text-align: left;
  font-size: 30px;
  display: flex;
align-items: center;
justify-content: space-between;
}
.main_top{
  width: 80%;
  margin: 0 auto;
}
.main_top1_txt {
  text-align: left;
  font-size: 14px;
  margin-top: 40px;
  color: gray;
  line-height: 25px;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
@media screen and (max-width: 1200px) {
  .header-bj{
   margin-top: 0px;
  }
}
@media screen and (max-width: 768px){
  .main_top_header{
    font-size: 20px;
  }
  .main_top1_header{
    font-size: 10px;
  }
  .main_top1_header>img{
    margin-top: -2px!important;
    width: 20px;
    margin-left: 5px;
  }
  .Breadcrumb{
    display: inline-block;
    text-align:left;
  }
  .Breadcrumb_item{
    float: left;
  }
  .main_top{
      width: 90%;
  }
  .main_top1{
      padding: 4%;
  }
  .main_bottom1{
      width: 90%;
      padding: 4%;
  }
  .main_top1_txt{
      margin-top: 20px;
  }
}
@media screen and (max-width: 576px){
  .main_top1_header>img{
    margin-right: -2%!important;
  }
}
</style>
<script>
import myfooter from "./zzj/footer_ESP";
import myheader from "./zzj/header_ESP";
import WOW from "wowjs";
export default {
  data() {
    return {
      hd: true,
      jia: true,
      jian: false,
      hd1: false,
      jia1: false,
      jian1: true,
      hd2: false,
      jia2: false,
      jian2: true,
      hd3: false,
      jia3: false,
      jian3: true,
      hd4: false,
      jia4: false,
      jian4: true,
      hd5: false,
      jia5: false,
      jian5: true,
      hd6: false,
      jia6: false,
      jian6: true,
      hd7: false,
      jia7: false,
      jian7: true,
      hd8: false,
      jia8: false,
      jian8: true,
      hd9: false,
      jia9: false,
      jian9: true,
      hd10: false,
      jia10: false,
      jian10: true,
      support: [],
      supportA: [],
      activeIndex: -1,
      activeIndexA: -1
    };
  },
  components: {
    myfooter: myfooter,
    myheader: myheader
  },
  methods: {
    ArticleDetail(index) {
        this.activeIndex = index;
    },
    ArticleDetailA(index) {
        this.activeIndexA = index;
    },
    wt: function() {
      if (this.hd == true) {
        this.hd = false;
        this.jia = false;
        this.jian = true;
      } else if (this.hd == false) {
        this.hd = true;
        this.jia = true;
        this.jian = false;
      }
    },
    wt1: function() {
      if (this.hd1 == true) {
        this.hd1 = false;
        this.jia1 = false;
        this.jian1 = true;
      } else if (this.hd1 == false) {
        this.hd1 = true;
        this.jia1 = true;
        this.jian1 = false;
      }
    },
    wt2: function() {
      if (this.hd2 == true) {
        this.hd2 = false;
        this.jia2 = false;
        this.jian2 = true;
      } else if (this.hd2 == false) {
        this.hd2 = true;
        this.jia2 = true;
        this.jian2 = false;
      }
    },
    wt3: function() {
      if (this.hd3 == true) {
        this.hd3 = false;
        this.jia3 = false;
        this.jian3 = true;
      } else if (this.hd3 == false) {
        this.hd3 = true;
        this.jia3 = true;
        this.jian3 = false;
      }
    },
    wt4: function() {
      if (this.hd4 == true) {
        this.hd4 = false;
        this.jia4 = false;
        this.jian4 = true;
      } else if (this.hd4 == false) {
        this.hd4 = true;
        this.jia4 = true;
        this.jian4 = false;
      }
    },
    wt5: function() {
      if (this.hd5 == true) {
        this.hd5 = false;
        this.jia5 = false;
        this.jian5 = true;
      } else if (this.hd5 == false) {
        this.hd5 = true;
        this.jia5 = true;
        this.jian5 = false;
      }
    },
    wt6: function() {
      if (this.hd6 == true) {
        this.hd6 = false;
        this.jia6 = false;
        this.jian6 = true;
      } else if (this.hd6 == false) {
        this.hd6 = true;
        this.jia6 = true;
        this.jian6 = false;
      }
    },
    wt7: function() {
      if (this.hd7 == true) {
        this.hd7 = false;
        this.jia7 = false;
        this.jian7 = true;
      } else if (this.hd7 == false) {
        this.hd7 = true;
        this.jia7 = true;
        this.jian7 = false;
      }
    },
    wt8: function() {
      if (this.hd8 == true) {
        this.hd8 = false;
        this.jia8 = false;
        this.jian8 = true;
      } else if (this.hd8 == false) {
        this.hd8 = true;
        this.jia8 = true;
        this.jian8 = false;
      }
    },
    wt9: function() {
      if (this.hd9 == true) {
        this.hd9 = false;
        this.jia9 = false;
        this.jian9 = true;
      } else if (this.hd9 == false) {
        this.hd9 = true;
        this.jia9 = true;
        this.jian9 = false;
      }
    },
    wt10: function() {
      if (this.hd10 == true) {
        this.hd10 = false;
        this.jia10 = false;
        this.jian10 = true;
      } else if (this.hd10 == false) {
        this.hd10 = true;
        this.jia10 = true;
        this.jian10 = false;
      }
    },
  },

    created() {
        this.axios
        .get("/api/support/index?classifyID=27&page=1&perNum=100")
        .then(res => {
            this.supportA = res.data.supList;
            console.log(this.supportA);
        });
        this.axios
        .get("/api/support/index?classifyID=28&page=1&perNum=100")
        .then(res => {
            this.support = res.data.supList;
            console.log(this.support);
        });
    },

  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/support_ESP.vue